export default "__VITE_ASSET__Dm_7Rg$q__"